import { render } from "./base-initial-screen.vue?vue&type=template&id=1fd3e946&ts=true"
import script from "./base-initial-screen.vue?vue&type=script&lang=ts"
export * from "./base-initial-screen.vue?vue&type=script&lang=ts"

import "./base-initial-screen.vue?vue&type=style&index=0&id=1fd3e946&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__